import request from './request'

// 通过体检编号和md5之后的手机号登录
export function loginByKey(examno, authkey) {
    let postParam = {
        examno,
        authkey
    };
    return request.post("/api/queue/loginByKey", postParam);
}

// 查询
export function queryState(key, examno) {
    let postParam = {
        key,
        examno
    };
    return request.post("/api/queue/queryState", postParam);
}
